import { render, staticRenderFns } from "./Comparator.vue?vue&type=template&id=03e4e648&"
import script from "./Comparator.vue?vue&type=script&lang=js&"
export * from "./Comparator.vue?vue&type=script&lang=js&"
import style0 from "./Comparator.vue?vue&type=style&index=0&id=03e4e648&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports